import * as THREE from 'three';

export class LoadingManager {
    constructor() {
        this.manager = new THREE.LoadingManager();
        this.totalItems = 0;
        this.loadedItems = 0;
        this.progress = 0;
        
        this.onProgress = null;
        this.onComplete = null;
        this.onError = null;
        
        this.setupManager();
    }

    setupManager() {
        this.manager.onStart = (url, itemsLoaded, itemsTotal) => {
            this.totalItems = itemsTotal;
            this.loadedItems = itemsLoaded;
            console.log(`Started loading: ${itemsLoaded} of ${itemsTotal} files.`);
        };

        this.manager.onProgress = (url, itemsLoaded, itemsTotal) => {
            this.loadedItems = itemsLoaded;
            this.totalItems = itemsTotal;
            this.progress = itemsLoaded / itemsTotal;
            
            if (this.onProgress) {
                this.onProgress(this.progress);
            }
            
            console.log(`Loading progress: ${itemsLoaded} of ${itemsTotal} files loaded.`);
        };

        this.manager.onLoad = () => {
            console.log('All assets loaded successfully!');
            
            setTimeout(() => {
                if (this.onComplete) {
                    this.onComplete();
                }
            }, 500);
        };

        this.manager.onError = (url) => {
            console.error(`Failed to load: ${url}`);
            
            if (this.onError) {
                this.onError(url);
            }
        };
    }

    setProgress(value) {
        this.progress = Math.max(this.progress, value);
        
        if (this.onProgress) {
            this.onProgress(this.progress);
        }
        
        if (this.progress >= 1 && this.onComplete) {
            setTimeout(() => {
                this.onComplete();
            }, 300);
        }
    }

    addItem() {
        this.totalItems++;
    }

    itemLoaded() {
        this.loadedItems++;
        this.progress = this.loadedItems / this.totalItems;
        
        if (this.onProgress) {
            this.onProgress(this.progress);
        }
    }
}